/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTireSide32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.75 16a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0zM16 14.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16 5.924c5.565 0 10.076 4.51 10.076 10.076 0 5.565-4.51 10.076-10.076 10.076-5.565 0-10.076-4.51-10.076-10.076 0-5.565 4.51-10.076 10.076-10.076zM24.576 16c0-.498-.042-.987-.124-1.462H21.96a2.75 2.75 0 01-2.608-3.625l.81-2.414a8.518 8.518 0 00-2.787-.966l-.875 2.61a2.75 2.75 0 01-4.2 1.368L9.997 9.875a8.6 8.6 0 00-1.714 2.381l2.115 1.502a2.75 2.75 0 010 4.485l-2.115 1.5a8.6 8.6 0 001.714 2.382l2.305-1.636a2.75 2.75 0 014.199 1.368l.875 2.61a8.516 8.516 0 002.787-.966l-.81-2.414a2.75 2.75 0 012.608-3.625h2.492c.082-.475.124-.963.124-1.462zM21.45 9.377a8.594 8.594 0 012.601 3.66H21.96a1.25 1.25 0 01-1.186-1.647l.676-2.013zM11.2 8.891a8.534 8.534 0 014.63-1.466l-.752 2.241a1.25 1.25 0 01-1.91.622l-1.967-1.397zm-1.671 6.09l-1.795-1.274c-.203.73-.31 1.499-.31 2.293s.107 1.563.31 2.293l1.795-1.274a1.25 1.25 0 000-2.038zm6.3 9.594a8.533 8.533 0 01-4.628-1.466l1.968-1.397a1.25 1.25 0 011.909.622l.751 2.24zm8.222-5.613a8.594 8.594 0 01-2.601 3.66l-.675-2.012a1.25 1.25 0 011.185-1.648h2.091z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16 .25C24.698.25 31.75 7.302 31.75 16S24.698 31.75 16 31.75.25 24.698.25 16 7.302.25 16 .25zm.742 1.519v1.723a.75.75 0 01-1.5 0V1.77a14.193 14.193 0 00-8.776 3.639l1.22 1.22a.75.75 0 01-1.061 1.06l-1.22-1.22A14.194 14.194 0 001.77 15.25H3.5a.75.75 0 010 1.5H1.77a14.193 14.193 0 003.639 8.784l1.228-1.228a.75.75 0 011.06 1.06L6.47 26.595a14.193 14.193 0 008.788 3.637v-1.74a.75.75 0 011.5 0v1.74a14.194 14.194 0 008.785-3.648l-1.229-1.228a.75.75 0 111.061-1.06l1.227 1.226a14.193 14.193 0 003.63-8.788H28.5a.75.75 0 010-1.5h1.73a14.194 14.194 0 00-3.647-8.776l-1.22 1.22a.75.75 0 11-1.06-1.06l1.218-1.22a14.193 14.193 0 00-8.78-3.628z'
      />
    </svg>
  );
}

export default SvgTireSide32;
